export async function setMagentoPageTitle(titleHtml) {
    const selectors = [
        '.feed-picker__title .page-title .base'
    ];

    for (let i = 0; i < 20; i++) {
        for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (el) {
                el.innerHTML = titleHtml;
                return true;
            }
        }
        await new Promise((r) => requestAnimationFrame(r));
    }
    return false;
}
